import React, { useState } from 'react';
import { useStore } from '../../store/useStore';
import { Card } from '../common/Card';
import { MarketSlotItem } from './market/MarketSlot';
import { ListingModal } from './market/ListingModal';
import { MarketAnalytics } from './market/MarketAnalytics';
import type { MarketSlot } from '../../types';

export const MarketPanel = () => {
    const marketSlots = useStore((state) => state.marketSlots || []); // Safety fallback
    const unlockNextSlot = useStore((state) => state.unlockNextSlot);
    const cancelListing = useStore((state) => state.cancelListing);
    const claimListing = useStore((state) => state.claimListing);

    const [selectedSlot, setSelectedSlot] = useState<number | null>(null);
    const [activeTab, setActiveTab] = useState<'exchange' | 'analytics'>('exchange');

    const handleSlotClick = (slot: MarketSlot) => {
        if (!slot.listing) {
            setSelectedSlot(slot.id);
        }
    };

    return (
        <Card title="Grand Exchange">
            {/* Custom Segmented Control for Tabs */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
                <div className="segmented-control">
                    <button
                        onClick={() => setActiveTab('exchange')}
                        className={`segment-btn ${activeTab === 'exchange' ? 'active' : ''}`}
                    >
                        Trading Floor
                    </button>
                    <button
                        onClick={() => setActiveTab('analytics')}
                        className={`segment-btn ${activeTab === 'analytics' ? 'active' : ''}`}
                    >
                        Market Analytics
                    </button>
                </div>
            </div>

            {activeTab === 'exchange' && (
                <div className="market-container">
                    <div className="market-grid">
                        {marketSlots.map(slot => (
                            <MarketSlotItem
                                key={slot.id}
                                slot={slot}
                                onUnlock={unlockNextSlot}
                                onClick={handleSlotClick}
                                onCancel={cancelListing}
                                onClaim={claimListing}
                            />
                        ))}
                    </div>
                </div>
            )}

            {activeTab === 'analytics' && <MarketAnalytics />}

            {selectedSlot !== null && (
                <ListingModal
                    isOpen={true}
                    onClose={() => setSelectedSlot(null)}
                    slotId={selectedSlot}
                />
            )}
        </Card>
    );
};
